const warned = {};
const warnOnce = (id, ...data) => {
    if (warned[id]) {
        return;
    }
    warned[id] = true;
    console.warn(...data);
};
export default warnOnce;
